import { InjectionToken } from '@angular/core'
import { CustomerAccount } from '../types'

export abstract class BaseCustomerService {
  abstract get parentCompany(): CustomerAccount
  abstract get selectedBranch(): CustomerAccount
}
export const CUSTOMER_SERVICE = new InjectionToken<BaseCustomerService>('CUSTOMER_SERVICE')
